import { SVGProps } from 'react';

export const QrCodeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="#999">
      <path d="M0 0v7h7V0H0zm5 5H2V2h3v3zM0 17v7h7v-7H0zm5 5H2v-3h3v3zM17 0v7h7V0h-7zm5 5h-3V2h3v3zM22 9v6h-5v2h7V9zM17 19v5h2v-3h3v3h2v-5zM9 0v2h4v5h2V0z" />
      <path d="M13 9v4H9v6h4v5h2v-7h-4v-2h4v-4h2v2h2V9z" />
      <path d="M9 21h2v3H9zM4 13h3v2H4z" />
      <path d="M9 4v5H0v6h2v-4h9V4z" />
    </g>
  </svg>
);
